var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('a-row',{attrs:{"type":"flex","justify":"center","align":"top"}},[_c('a-col',{attrs:{"span":16}},[_c('HelloWorld'),_c('schedule')],1),_c('a-col',{attrs:{"span":8}},[_c('InformList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }